class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

     setTimeout(() => {
      initCartImageZoom();
    }, 500);
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      
      $.getJSON('/cart.js', function(cart){ 
        let cart_final_total_update = (cart.total_price / 100);
        if(currency_code != 'USD'){
          getCurreny(cart_min_threshold);
          function getCurreny(priceconvert) {
            let threshold_convert_amount_update = (Currency.convert(priceconvert, 'USD', currency_code)).toFixed(2),
              threshol_remain_amount_update = (threshold_convert_amount_update - cart_final_total_update).toFixed(2);

            if (threshold_convert_amount_update < cart_final_total_update) {
              document.querySelector('.drawer_cart_total-message').style.display = 'none';
              document.querySelectorAll('.shipping_eligable_infowrapper').forEach((shipping_info) => {
                shipping_info.style.display = 'none';
              });
              document.querySelector('.drawer_carttotal-remain-amount').innerHTML = currency_symbol + '' + 0;
              document.querySelectorAll('.cart__checkout-button').forEach((checkoutbtn) => checkoutbtn.classList.remove('cart__checkout-totaldisabled'));
            } else {
              document.querySelector('.drawer_cart_total-message').style.display = 'block';
              document.querySelectorAll('.shipping_eligable_infowrapper').forEach((shipping_info) => {
                shipping_info.style.display = 'flex';
              });
              document.querySelector('.drawer_carttotal-remain-amount').innerHTML = currency_symbol + '' + threshol_remain_amount_update;
              document.querySelectorAll('.cart__checkout-button').forEach((checkoutbtn) => checkoutbtn.classList.add('cart__checkout-totaldisabled'));
            }
          }
        }else{
          let cart_mini_thresholdamount = 0;
          if(cart_final_total_update > cart_min_threshold){
          }else{
             cart_mini_thresholdamount = cart_min_threshold - cart_final_total_update;
          }
          if(cart_final_total_update >= cart_min_threshold){
            $('.cart__ctas .cart__checkout-button').removeClass('cart__checkout-totaldisabled');
            $('.drawer_cart_total-message').css('display','none');
            document.querySelectorAll('.shipping_eligable_infowrapper').forEach((shipping_info) => {
              shipping_info.style.display = 'none';
            });
          }else{
            $('.cart__ctas .cart__checkout-button').addClass('cart__checkout-totaldisabled');
            $('.drawer_cart_total-message').css('display','block');
            document.querySelectorAll('.shipping_eligable_infowrapper').forEach((shipping_info) => {
              shipping_info.style.display = 'flex';
            });
          }
        }
      });
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      if (typeof POSession !== 'undefined' && POSession.extension) {
        POSession.extension.setupPage();
        POSession.extension.returnToProcButton();
      }

    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
